import React from 'react';
import { ScrollView } from 'react-native';

import {
  Container,
  Content,
  InfoList,
  InfoItem,
  InfoItemTitle,
  InfoDescription,
  InfoItemContent,
  Footer,
  LinkButtonContainer,
  HelpVideoContainer,
  HelpVideoThumb,
  VideoInfos,
  HelpVideoTitle,
  HelpVideoSubtitle,
} from './styles';

import { Titles } from '../../components/Interface/Typographies/Titles';
import { Icon } from '../../components/Interface/Typographies/Icon';
import { Button } from '../../components/Interface/Forms/Buttons/Button';
import { LinkButton } from '../../components/Interface/Forms/Buttons/LinkButton';
import { Linking } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import thumbVideoIndGanhe from '../../assets/images/banners/thumb-indique.webp';

import { useTheme } from 'styled-components/native';

import { Header as HeaderButton } from '../../components/Interface/Headers/Header';
import { useAuth } from '../../context/auth';

export function BaratinhasAjuda() {
  const theme = useTheme();
  const navigation = useNavigation();
  const { isLogged, openSign } = useAuth();
  const YOUTUBE_URL = 'https://youtu.be/IZy126reXfM?is=l_99cgYLrkUsz2wj';

  function handlePaymentHistory() {
    if (!isLogged) {
      return openSign();
    }
    navigation.navigate('BaratinhasHistory');
  }

  return (
    <>
      {/* <TouchableWithoutFeedback onPress={() => Platform.OS !== "web" && Keyboard.dismiss()} accessible={false}>*/}
      <Container>
        <HelpVideoContainer
          onPress={() => Linking.openURL(YOUTUBE_URL)}
          activeOpacity={1}>
          <HelpVideoThumb source={thumbVideoIndGanhe}>
            <HeaderButton
              icon="chevron-left"
              statusBarLight
              color={theme.colors.shape}
            />
            <VideoInfos>
              <HelpVideoTitle>Veja como ganhar baratinhaZ</HelpVideoTitle>
              <HelpVideoSubtitle>
                Clique e assista ao vídeo
              </HelpVideoSubtitle>
            </VideoInfos>
          </HelpVideoThumb>
        </HelpVideoContainer>

        <Content>
          <ScrollView
            style={{ flex: 1, borderRadius: 24 }}
            contentContainerStyle={{ padding: 24, paddingBottom: 24 }}
            showsVerticalScrollIndicator={false}
          >
            <Titles
              title="BaratinhaZ"
              subtitle="Saiba como funciona e aumente seus ganhos com indicações!"
            />

            <InfoList>
              <InfoItem>
                <Icon name="coins" awesome5 />
                <InfoItemContent>
                  <InfoItemTitle>Cashback</InfoItemTitle>
                  <InfoDescription>
                    A cada abastecimento você ganha baratinhaZ.
                  </InfoDescription>
                </InfoItemContent>
              </InfoItem>
              <InfoItem>
                <Icon name="user-friends" awesome5 />
                <InfoItemContent>
                  <InfoItemTitle>Indique e Ganhe</InfoItemTitle>
                  <InfoDescription>
                    A cada abastecimento que seu indicado fizer, você também ganha!
                  </InfoDescription>
                </InfoItemContent>
              </InfoItem>
              <InfoItem>
                <Icon name="sync-alt" awesome5 />
                <InfoItemContent>
                  <InfoItemTitle>Gire e Ganhe</InfoItemTitle>
                  <InfoDescription>
                    Todo dia voce pode girar a roleta da sorte e tentar ganhar BaratinhaZ.
                  </InfoDescription>
                </InfoItemContent>
              </InfoItem>
              <InfoItem>
                <Icon name="calendar" awesome5 />
                <InfoItemContent>
                  <InfoItemTitle>Checkin Diário</InfoItemTitle>
                  <InfoDescription>
                    Entre no aplicativo diáriamente e pegue suas baratinhaZ.
                  </InfoDescription>
                </InfoItemContent>
              </InfoItem>
              <InfoItem>
                <Icon name="award" awesome5 />
                <InfoItemContent>
                  <InfoItemTitle>Conquistas</InfoItemTitle>
                  <InfoDescription>
                    Aumente seu nível e ganhe mais baratinhaZ por abastecimento.
                  </InfoDescription>
                </InfoItemContent>
              </InfoItem>
            </InfoList>
          </ScrollView>
        </Content>

        <Footer>

          <Button
            title="Ver extrato"
            enabled
            onPress={handlePaymentHistory}
          />

          <LinkButtonContainer>
            <LinkButton
              action={() =>
                navigation.navigate('Help')
              }
              enabled
              text="Preciso de ajuda"
            />
          </LinkButtonContainer>
        </Footer>

      </Container>
      {/*</TouchableWithoutFeedback>*/}
    </>
  );
}
